export default function getActivitiesQuery(locale: string) {
  const query = `live==true && _type=="activity" && __i18n_lang=="${locale}" && !(_id in path("drafts.**"))`;

  return groq`{
    'documents': *[${query}] | order(coalesce(__i18n_base->orderRank, orderRank)) {
      detailPageSettings,
      category->,
      url,
      orderRank,
      seasonSwitch
    }
  }`;
}
